import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Card_1 from '../components/Card_1';
import { ArrowLeft } from 'lucide-react';
import MobileNav from '../components/MobileNav';


export default function Category() {
    const location = useLocation();
    const { category } = location.state || {};
    const videos = category?.Content || [];

    const [visibleCount, setVisibleCount] = useState(20); // start with 12 videos

    const handleViewMore = () => {
        setVisibleCount((prev) => prev + 12); // load 12 more on each click
    };

    useEffect(()=>{
        window.scrollTo(0,0)
    },[])

    return (
      <div>
            <section className='container' style={{marginBottom:'7rem'}} >
            <div className='d-flex flex-row align-items-center gap-2 my-4' >
                <ArrowLeft size={'30px'} color='white' onClick={()=>window.history.back()} style={{cursor:'pointer'}} />
                <h2 className='pink m-0'>  {category?.Name}</h2>
            </div>

            <div className='video-grid'>
                {videos.slice(0, visibleCount).map((video, VidIndex) => (
                    <Card_1 video={video} channel={videos} key={VidIndex} />
                ))}
            </div>

            {visibleCount < videos.length && (
                <div className="text-center my-4">
                    <button
                        className="btn btn-outline-light"
                        onClick={handleViewMore}
                    >
                        View More
                    </button>
                </div>
            )}
        </section>
        <MobileNav/>
      </div>
    );
}
